import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { SectionHeading } from "./SectionHeading";
import { faqs } from "../data/content";
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white px-4 py-16 sm:py-20" data-id="element-118" data-mp="1cgb9dgf74mgq">
      <div className="mx-auto max-w-3xl" data-id="element-119" data-mp="2a2idyqbi2et3">
        <SectionHeading eyebrow="Frequently asked questions" title="Your questions, answered" data-id="element-120" data-mp="2a05x6ghhaahm" />

        <div className="mt-10 divide-y divide-cream-dark border-y border-cream-dark" data-id="element-121" data-mp="253xe4s05tx56">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} data-id="element-122" data-mp="1v4g643xfr761" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-4 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-123" data-mp="oow35ckatl07">
                  <span className="text-[17px] font-bold leading-snug text-navy" data-id="element-124" data-mp="1pn321ssms709">{faq.question}</span>
                  <ChevronDownIcon className={`mt-0.5 h-5 w-5 shrink-0 text-gold-dark transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-125" data-mp="1aoiuu0wly512" />
                </button>
                <AnimatePresence initial={false} data-id="element-126" data-mp="16nyy2yfy53fg">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-127" data-mp="16ps72ke17zqm">
                      <div className="space-y-2 pb-5 text-[16px] leading-relaxed text-muted" data-id="element-128" data-mp="myojxovumqjg">
                        {faq.answer.map(p => <p key={p} data-id="element-129" data-mp="2kvwz2i88jr4x">{p}</p>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="mt-10" data-id="element-130" data-mp="2aysa6an09hkf">
          <CTAButton label="I'm ready to structure my clinical workflow" note="One-Time Payment of $27 USD · Instant Download · 7-Day Money-Back Guarantee" data-id="element-131" data-mp="2azk4li4v9994" />
        </div>
      </div>
    </section>;
}